// extracted by mini-css-extract-plugin
export var wrapper = "founding-team-module--wrapper--TwI8X";
export var figure = "founding-team-module--figure--iQzhf";
export var caption = "founding-team-module--caption--Z-F28";
export var paragraphs = "founding-team-module--paragraphs--vDmsO";
export var paragraph = "founding-team-module--paragraph--X9pm-";